export default {
	methods: {
		goBanner() {
			// 似乎是后台预览首页用的，阻止二次跳转
			if(this.isPreview==1){
				return
			}
			if(this.relevance_type == 1) {
				this.$router.push({
					path:"/productDetail",
					query:{
						id: this.relevance_id
					}
				})
			}
			// 商品分类
			else if(this.relevance_type == 2) {
				// url:"/pages/navigation/index?id="+this.relevance_id+"&componentId="+this.componentId
				this.$router.push({
					path: '/classify',
					query: {
						type: 1,
						id: this.relevance_id,
						componentId: this.componentId,
					}
				})
			}
			// 品牌
			else if(this.relevance_type == 3) {
				console.log('goBanner goBrand')
				this.$router.push({
					path: '/classify',
					query: {
						type: 0,
						id: this.relevance_id,
						componentId: this.componentId,
					}
				})
			}
		},
		// WARNING: 下面这些是小程序挪过来的，用作参考
		// // 将relevance_type处理为url
		// reletypeToUrl(item_arr) {
		// 	// relevance_type 类型：
		// 	// 0:不关联 1：商品 2：分类 3:品牌 4:公告
		// 	// relevance_id 进入类型对应页面的id参数
		// 	for(let item of item_arr) {
		// 		if(item.relevance_type === '1') {
		// 			item.url = `/pages/index/goodsDetail?id=${item.relevance_id}`
		// 		}
		// 		else if(item.relevance_type === '2') {
		// 			// item.url = `/pages/tabbar/classify/classify?id=${item.relevance_id}`
		// 			item.url = `/pages/navigation/index?id=${item.relevance_id}`
		// 		}
		// 		else if(item.relevance_type === '3') {
		// 			item.url = `/pages/brand/index?id=${item.relevance_id}`
		// 		}
		// 		else if(item.relevance_type === '4') {
		// 			item.url = `/pages/notice/index?id=${item.relevance_id}`
		// 		}
		// 		else {
		// 			item.url = '#'
		// 		}
		// 	}
		// },
	}
}


// WEBPACK FOOTER //
// ./src/components/modular/goBanner.js